// Color handling for chart exports: the live theme palette, the export
// background options and the palette adjustment that keeps labels readable
// on an explicit background.

import { themeColor } from '../theme';
import { PALETTES } from './mapIcons';

// Categorical colors for distinct data series: the theme primary/secondary
// first, then the fixed mid-tone donut palette, which reads on both light
// and dark surfaces.
export function seriesColor(index, palette = {}) {
  const colors = [palette.primary, palette.secondary, ...PALETTES.default].filter(Boolean);
  return colors[index % colors.length];
}

// The colors chart.js bakes into its markup, read from the design tokens.
export function themePalette() {
  return {
    primary: themeColor('--md-sys-color-primary', '#8b4513'),
    secondary: themeColor('--md-sys-color-secondary', '#5d4037'),
    onSurface: themeColor('--md-sys-color-on-surface', '#3e2723')
  };
}

// The background options offered by the export controls; 'theme' matches
// the on-screen result card surface.
export function resolveBackground(value) {
  switch (value) {
    case 'white':
      return '#ffffff';
    case 'black':
      return '#000000';
    case 'transparent':
      return 'transparent';
    case 'theme':
    default:
      return themeColor('--md-sys-color-surface-container-lowest', '#ffffff');
  }
}

// A palette whose text color stays readable on the resolved background;
// theme and transparent keep the live theme's on-surface color.
export function paletteForBackground(resolvedBackground) {
  const palette = themePalette();
  if (resolvedBackground === '#ffffff') palette.onSurface = '#3e2723';
  if (resolvedBackground === '#000000') palette.onSurface = '#ffffff';
  return palette;
}
